module.exports = __webpack_public_path__ + "1ca2f40503cf094624733b6601b9c2bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notifications/plane-flying-left.svg
// module id = 2094
// module chunks = 4